import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';

const LoadingCard = ({ children }) => {
  return (
    <Card
      sx={{
        width: { xs: '90%', sm: '60%', md: '50%', lg: '40%' }, // Responsive width
        maxWidth: '500px', // Prevents it from getting too wide
        minWidth: '300px', // Ensures a reasonable minimum size
        p: 3,
        borderRadius: 2,
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      variant="outlined"
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'JetBrains Mono NL',
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? 'hsl(0, 0%, 20%)'
                  : 'hsl(0, 0%, 85%)',
              fontWeight: 'bold',
            }}
          >
            EnergyXplorer
          </Typography>
        </Box>
        <CircularProgress />
        {children}
      </CardContent>
    </Card>
  );
};

export default LoadingCard;
